import React from 'react';
import LazyLoadImage from './LazyLoadImage';

/**
 * Datestring has following format: Y-m-d H:i:s
 * E.g. 2019-02-21 11:19:00
 */
const formatDate = dateString => {
  const [date, time] = dateString.split(' ');
  const [year, month, day] = date.split('-');
  const [hours, minutes] = time.split(':');

  return `${day}/${month}/${year} om ${hours}:${minutes}`;
};

const Image = ({ placeholder, src, name, source, onClick }) => (
  <div className="w-full relative group cursor-pointer flex aspect-square" onClick={onClick}>
    <LazyLoadImage
      placeholder={placeholder}
      src={src}
      alt={name}
      className="object-cover aspect-square w-full classic:object-contain classic:border classic:border-gray-500"
    />
    <div className="absolute top-0 left-0 h-full w-full pointer-events-none opacity-50 group-hover:bg-primary/60 classic:group-hover:bg-black" />
    <div className="absolute top-0 left-0 h-full w-full items-end hidden p-4 group-hover:flex text-left">
      <div>
        <div className="text-white text-lg split:text-gray-300">{source.description}</div>
        <div className="text-white mt-1 split:text-gray-400">{formatDate(source.taken_at)}</div>
      </div>
    </div>
  </div>
);

Image.defaultProps = {
  onClick: () => {}
};

export default Image;
